<template>
    <a :href="url">
        <img
          class="logo"
          src="/image/dot_logo.svg"
          alt="Dot Incorporation logo."
          width="100" height="40"
        />
    </a>
</template>

<script setup>
import { computed } from "vue";

const dotServiceSiteURL = process.env.VUE_APP_DOT_APPS_HOME;

// redirect url 여부 체크해서 홈화면 이동 href 설정
const url = computed(() => {
  const search = window.location.search;
  const seraParams = new URLSearchParams(search);
  const cb = seraParams.get("cb") || null;

  return cb ? new URL(cb).origin : dotServiceSiteURL;
});
</script>
